export default "__VITE_ASSET__Dbfr_q2H__"